import React, { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from 'react-feather';

interface SearchBarProps {
  onSearchChange?: (search: string) => void;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  onSearchChange,
  placeholder = 'Search...',
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    // Debounce search to avoid too many queries
    if (onSearchChange) {
      const timeoutId = setTimeout(() => {
        onSearchChange(searchQuery);
      }, 300);

      return () => clearTimeout(timeoutId);
    }
  }, [searchQuery, onSearchChange]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search size={20} />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      size="small"
      placeholder={placeholder}
      onChange={handleChange}
      value={searchQuery}
      sx={{ minWidth: 300 }}
    />
  );
};
